import { lazy } from 'react';

// ----------------------------------------------------------------------

const CustomerRealtionsPage = lazy(() => import('../pages/CustomerRealtions.page'));
const AddCustomerPage = lazy(() => import('../pages/AddCustomer.page'));
const ViewCustomerPage = lazy(() => import('../pages/ViewCustomer.page'));
const EditCustomerPage = lazy(() => import('../pages/EditCustomer.page'));
const ComplaintsPage = lazy(() => import('../pages/Complaints.pag'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));
const CustomerCommunicationPage = lazy(() => import('../pages/CustomerCommunication.page'));
const AddMessagePage = lazy(() => import('../pages/AddMessage.page'));
const MarketingPage = lazy(() => import('../pages/Marketing.page'));

// ----------------------------------------------------------------------

const CustomerRealtionsRoutes = [
    {
        path: 'customer-relations',
        children: [
            { element: <CustomerRealtionsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add-customer',
                element: <AddCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'view-customer/:customer_id',
                element: <ViewCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit-customer/:customer_id',
                element: <EditCustomerPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'complaints',
                children: [
                    {
                        element: <ComplaintsPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add',
                        element: <AddComplaintPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
            {
                path: 'customer-communication',
                children: [
                    {
                        element: <CustomerCommunicationPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add-message',
                        children: [
                            { element: <AddMessagePage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <AddMessagePage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'marketing',
                element: <MarketingPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { CustomerRealtionsRoutes };
